import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitApplication = (payload) =>
  axios.post(`${API}/applications`, payload).then((r) => r.data);

export const saveDraft = ({ id, email, payload, current_step, send_email }) =>
  axios.post(`${API}/drafts`, { id, email, payload, current_step, send_email: !!send_email })
    .then((r) => r.data);

export const loadDraft = (id) =>
  axios.get(`${API}/drafts/${id}`).then((r) => r.data);

export const uploadIdImage = (file, side) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("side", side); // "front" | "back"
  return axios
    .post(`${API}/uploads/id`, fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const fileViewUrl = (storagePath) => {
  const token = localStorage.getItem("gd_admin_token") || "";
  return `${API}/files/${storagePath}?auth=${encodeURIComponent(token)}`;
};

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password }).then((r) => r.data);

const authHeaders = () => {
  const token = localStorage.getItem("gd_admin_token") || "";
  return { headers: { "X-Admin-Token": token } };
};

export const listApplications = (status) =>
  axios
    .get(`${API}/applications${status && status !== "all" ? `?status=${status}` : ""}`, authHeaders())
    .then((r) => r.data);

export const updateApplication = (id, status, admin_notes) =>
  axios
    .patch(`${API}/applications/${id}`, { status, admin_notes }, authHeaders())
    .then((r) => r.data);

export const adminStats = () =>
  axios.get(`${API}/admin/stats`, authHeaders()).then((r) => r.data);
